import script from "./legoIcon.vue?vue&type=script&lang=js"
export * from "./legoIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/lego-component/components/element/legoIcon/legoIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "324ee298"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('324ee298', __exports__)) {
    api.reload('324ee298', __exports__)
  }
  
}


export default __exports__